import { createContext, useContext } from 'react';

import { useSuspenseQuery } from '@tanstack/react-query';

import { useSummarizationId } from 'hooks/useSummarizationId';
import Summarization from 'models/Summarization';
import { showSummarization, summarizationQueryKeys, summarizationQueryParams } from 'services/api/summarizations';

type SummarizationContextType = {
  summarization: Summarization | undefined;
};

export const SummarizationContext = createContext<SummarizationContextType>({
  summarization: undefined,
});

export function SummarizationProvider({ children }: { children: React.ReactNode }) {
  const summarizationId = useSummarizationId();

  const { data: summarization } = useSuspenseQuery({
    queryKey: summarizationQueryKeys.show({ id: summarizationId }),
    queryFn: () => showSummarization(summarizationQueryParams.show(summarizationId ?? '')),
  });

  return <SummarizationContext value={{ summarization }}>{children}</SummarizationContext>;
}

export function useSummarization() {
  const context = useContext(SummarizationContext);
  if (!context) {
    throw new Error('useSummarization must be used within a SummarizationProvider');
  }
  return context;
}
